import debounce from 'lodash.debounce';

export default {
  data() {
    return {
      cards: [],
      tallestCard: 200
    };
  },
  methods: {
    getTallestCard() {
      const selector = '.js-matchHeightA, .js-matchHeight1, .js-matchHeight2';
      this.cards = Array.from(document.querySelectorAll(selector));

      if (this.cards.length === 0) {
        this.setCardHeight();
        return;
      }

      const cardHeights = this.cards.map(card => card.offsetHeight);
      this.tallestCard = Math.max(...cardHeights);
      this.setCardHeight();
    },
    setCardHeight() {
      this.cards.forEach((card) => {
        card.style.minHeight = `${this.tallestCard}px`;
      });
    }
  },
  mounted() {
    window.addEventListener('resize', debounce(this.getTallestCard, 500));
    window.addEventListener('resultsLoaded', this.getTallestCard);
  },
  destroyed() {
    window.removeEventListener('resize', debounce(this.getTallestCard, 500));
    window.removeEventListener('resultsLoaded', this.getTallestCard);
  }
};
